import { TitleLoader } from "@via/components/loading/loading.tsx";
import { classNames } from "@via/utils/helpers.tsx";
import { type JSX } from "react";

// Define and export the enum
export enum HeadingSize {
  XSmall = "xsmall",
  Small = "small",
  Big = "big",
}

// Interface for component's props using the enum
interface PageHeadingProps {
  title: string | undefined;
  isLoading?: boolean;
  size?: HeadingSize;
}

export function PageHeading({
  title = "",
  isLoading,
  size = HeadingSize.Big,
}: PageHeadingProps): JSX.Element {
  return (
    <div
      id="page-heading"
      className={classNames(
        "page-heading",
        size === HeadingSize.Small || size === HeadingSize.XSmall
          ? "md:pb-2 md:pt-2"
          : ""
      )}>
      <h2
        className={classNames(
          "via-h2 font-bold sm:truncate md:leading-normal",
          size === HeadingSize.Small ? "leading-9 md:text-2xl" : "",
          size === HeadingSize.XSmall
            ? "leading-6 md:text-lg"
            : size === HeadingSize.Big
              ? "font-bold leading-10 sm:tracking-tight md:text-3xl"
              : ""
        )}>
        {isLoading ? <TitleLoader /> : <span>{title}</span>}
      </h2>
    </div>
  );
}
